import React, { useState } from 'react';
import { BaseAttachment } from '../../../types/BaseAttachment';

type TaskFilePreviewProps = {
  attachment: BaseAttachment;
};

export const supportedImageTypes = ['png', 'jpg', 'jpeg', 'gif', 'webp'];
export const supportedDocTypes = ['pdf'];

export const TaskFilePreview: React.FC<TaskFilePreviewProps> = ({ attachment }) => {
  const [error, setError] = useState(false);
  const fileExt = attachment.filename.split('.').pop()?.toLowerCase() || '';

  if (error) {
    return <div className="text-red-500 text-center">Error loading file. Please try downloading it instead.</div>;
  }

  if (supportedImageTypes.includes(fileExt)) {
    return (
      <img
        src={attachment.url}
        alt={attachment.filename}
        style={{ width: 'auto', maxWidth: '100%', height: 'auto', maxHeight: '100%', objectFit: 'contain' }}
        onError={() => setError(true)}
      />
    );
  }

  if (supportedDocTypes.includes(fileExt)) {
    return (
      <iframe
        src={attachment.url}
        title={attachment.filename}
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        onError={() => setError(true)}
      />
    );
  }

  return <button onClick={() => window.open(attachment.url, '_blank')}>Open {attachment.filename}</button>;
};
